import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { useMemo as n } from "react";
import u from "./Hamburger/Hamburger.js";
import d from "./Menu/Menu.js";
import f from "./Shade/Shade.js";
import { SideNavProvider as l } from "./context.js";
import { Wrapper as c } from "./styled.js";
const p = (m, r = 0) => m.map(({ id: o, text: t, href: s, subItems: i }) => ({
  id: o,
  text: t,
  href: s,
  itemLevel: r,
  state: "Collapsed",
  ...i ? {
    subItems: p(i, r + 1)
  } : null
})), j = ({ isOpen: m, items: r = [], ...o }) => {
  const t = n(() => p(r), [r]);
  return /* @__PURE__ */ e(l, { isOpen: !!m, items: t, children: /* @__PURE__ */ a(c, { children: [
    /* @__PURE__ */ e(u, {}),
    /* @__PURE__ */ e(d, { ...o }),
    /* @__PURE__ */ e(f, {})
  ] }) });
};
export {
  j as SideNav,
  j as default
};
